export * from "./src/http-loader";



//////////////////
// WEBPACK FOOTER
// ./~/@ngx-translate/http-loader/index.js
// module id = 511
// module chunks = 13